<div fxLayout="column" *ngIf="histories">
  <div class="last-history" *ngIf="owner || lastHistory">
    <ng-container *ngIf="owner; else lastHistoryBlock">
      <span>{{'contact_history.call.contact_owner'|translate}}: </span>
      <a mat-button color="primary" (click)="transferCall(owner.id)">{{owner.name}}</a>
    </ng-container>
    <ng-template #lastHistoryBlock>
      <ng-container *ngIf="lastHistory.userId">
        <span>{{'contact_history.call.last_handled_by'|translate}} </span>
        <a mat-button color="primary" (click)="transferCall(lastHistory)">{{lastHistory.agentName}}</a>
      </ng-container>
    </ng-template>
  </div>
  <mat-accordion>
    <mat-expansion-panel *ngFor="let history of histories;let i=index;" [expanded]="i === 0">
      <mat-expansion-panel-header>
        <div>
          <strong
            [ngClass]="{'mat-text-warn': !history.direction && history.type=='call' && !history.duration}">{{history.startTime}}</strong>
          &nbsp;
          <ng-container [ngSwitch]="history.type">
            <ng-container *ngSwitchCase="'call'">
              <span *ngIf="history.direction === 1">
                {{'contact_history.call.outbound'|translate}}
              </span>
              <span *ngIf="history.direction === 0" [ngClass]="{'mat-text-warn': !history.duration}">
                {{'contact_history.call.inbound'|translate}}
              </span>
              <a mat-button color="primary" (click)="transferCall(history.userId)">{{history.agentName}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'sms'">
              <span *ngIf="history.direction === undefined">{{'contact_history.sms.title'|translate}}</span>
              <span *ngIf="history.direction === 1">{{'contact_history.sms.outbound'|translate}}</span>
              <span *ngIf="history.direction === 0">{{'contact_history.sms.inbound'|translate}}</span>
            </ng-container>
            <ng-container *ngSwitchCase="'mail'">
              <span *ngIf="history.direction === 1">{{'contact_history.email.outbound'|translate}}</span>
              <span *ngIf="history.direction === 0">{{'contact_history.email.inbound'|translate}}</span>
              <a mat-button color="primary" *ngIf="history.userId" (click)="transferCall(history.userId)">
                {{history.agentName}}
              </a>
            </ng-container>
            <ng-container *ngSwitchCase="'order'">
              <a mat-button color="primary" href="{{history.link}}" target="_blank">Link</a>
            </ng-container>
          </ng-container>
        </div>
      </mat-expansion-panel-header>
      <div class="content" *ngFor="let content of history.contents">
        {{content}}
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
